import { ButtonHTMLAttributes, FC } from 'react';

import { Icon } from '@/shared/ui';

import styles from './resetFilter.module.scss';

type ResetFilterProps = ButtonHTMLAttributes<HTMLButtonElement>;

const ResetFilter: FC<ResetFilterProps> = (props) => {
  const { ...rest } = props;
  return (
    <button {...rest} className={styles.container}>
      <Icon name="crossSmall" />
      <p className={styles.container__text}>Сбосить</p>
    </button>
  );
};

export default ResetFilter;
